import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function updateCustomerBilling(token: string, params: any): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('updateCustomerBilling')
    .setMethod('POST')
    .setProps([{token: token, input: params}])
    .send();
}
